import {IconButton, TextField, Tooltip} from '@material-ui/core';
import {
  AddCircleOutline as AddIcon,
  AssignmentReturnOutlined as AssignmentReturnOutlinedIcon,
  Edit as EditIcon,
} from '@material-ui/icons';
import Axios from 'axios';
import MaterialTable from 'material-table';
import React, {useEffect, useState} from 'react';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import AdminAddSchoolForm from '../AdminAddSchoolForm';
import AdminUpdateSchoolForm from '../AdminUpdateSchoolForm';
import PopupForm from '../utils/PopupForm';
import TableTitle from '../utils/TableTitle';

export function AdminSchoolsTable() {
  const [schools, setSchools] = useState([]);
  const [school, setSchool] = useState({});
  const [openDialog, setOpenDialog] = useState(null);
  const closeDialog = () => setOpenDialog(null);

  useEffect(() => {
    const getSchools = async () => {
      const result = await Axios.get('/api/school');

      setSchools(result.data);
    };
    getSchools();
  }, []);

  const columns = [
    {title: 'Name', field: 'name'},
    {
      title: 'Signup Link',
      field: 'signupCode',
      render: (rowData) => {
        const baseUri = document.baseURI.split('/').slice(0, 3).join('/');
        const signupCode = rowData.signupCode ? rowData.signupCode : '';
        const schoolSignupLink = `${baseUri}/googleTeacher/${signupCode}`;
        return (
          <>
            <TextField
              id={`school-signup-link-${rowData._id}`}
              size="small"
              disabled
              label="Classroom signup link"
              variant="outlined"
              value={schoolSignupLink}
            />
            <Tooltip title="Copy signup link">
              <IconButton
                aria-label="Copy signup link"
                onClick={() => navigator.clipboard.writeText(schoolSignupLink)}
              >
                <AssignmentReturnOutlinedIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];
  return (
    <div style={{maxWidth: '100%'}}>
      <MaterialTable
        localization={tableLocalization}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: 'Add School',
            isFreeAction: true,
            onClick: () => setOpenDialog('add'),
          },
          {
            icon: () => <EditIcon />,
            tooltip: 'Update School',
            onClick: (event, rowData) => {
              setSchool(rowData);
              setOpenDialog('update');
            },
          },
        ]}
        options={{
          // Column drag handles render a role="button" inside each sortable
          // header button (nested interactive controls, WCAG 4.1.2).
          draggable: false,
          actionsColumnIndex: -1,
        }}
        title={<TableTitle>{'STEMhero Schools'}</TableTitle>}
        columns={columns}
        data={schools}
        icons={tableIcons}
      />
      <PopupForm
        component={AdminAddSchoolForm}
        title="Create School"
        open={openDialog === 'add'}
        onClose={closeDialog}
      />
      <PopupForm
        component={AdminUpdateSchoolForm}
        school={school}
        title="Update School"
        open={openDialog === 'update'}
        onClose={closeDialog}
      />
    </div>
  );
}
